// Chip Stack Layer: Dynamic stacking, color, and physics
import * as PIXI from 'pixi.js';
import { hexToPixi } from './colorUtils';

export function createChipStack(x: number, y: number, chipCounts: number[], chipColors: string[], stackId: string) {
  const container = new PIXI.Container();
  let yOffset = 0;
  chipCounts.forEach((count, i) => {
    for (let j = 0; j < count; j++) {
      const chip = new PIXI.Graphics();
  chip.ellipse(0, 0, 22, 8).fill({ color: hexToPixi(chipColors[i % chipColors.length]) });
      chip.x = x + (Math.random() - 0.5) * 4;
      chip.y = y - yOffset + (Math.random() - 0.5) * 2;
      chip.zIndex = y - yOffset;
      container.addChild(chip);
      yOffset += 7;
    }
  });
  (container as any).label = `chip-stack-${stackId}`;
  return container;
}
